<div class="chart-area">
    <div class="header-section">
        <div class="header-left">
            <img src="assets/images/icon/chart/heart-rate-white.svg" class="heart-icon" alt="">
            <div class="average-text">平均値：68</div>
        </div>
        <div class="threshold-text">閾値：60〜80</div>
    </div>
    <div class="chart-body">
        <canvas id="heartRateChart"></canvas>
    </div>
</div>